import type {ComponentProps} from 'react';

import {Tag} from '@/modules/commerce/tag';

import type {BrandTagFragment} from './query';

type BrandTagProps = Omit<ComponentProps<typeof Tag>, 'children'> & {
	brand: BrandTagFragment;
};

export const BrandTag = ({brand, ...rest}: BrandTagProps) => {
	return <Tag {...rest}>{brand.name}</Tag>;
};
